/** @format */

import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';
import ClubForm from './ClubForm';
import ClubStatusBadge from './ClubStatusBadge';
import { submitClubForm } from './clubApi';

const EditClub = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [club, setClub] = useState(null);

  useEffect(() => {
    fetchClub();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchClub = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/club/my/${id}`,
      {},
      (res) => {
        const found = res.data.data;

        if (found.status === 1) {
          error('باشگاه تأیید شده قابل ویرایش نیست');
          navigate('/panel/clubs/my');
          return;
        }

        setClub(found);
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('دریافت اطلاعات باشگاه با خطا مواجه شد');
      },
    );
  };

  const handleSubmit = async ({ values, files, removeImageIds }) => {
    setSubmitLoading(true);

    try {
      await submitClubForm({
        method: 'put',
        url: `/panel/club/${id}`,
        values,
        files,
        removeImageIds,
      });
      success('باشگاه با موفقیت ویرایش شد و مجدداً در انتظار بررسی است');
      navigate('/panel/clubs/my', { replace: true });
    } catch (err) {
      setSubmitLoading(false);
      const message = err?.response?.data?.message;
      const errors = err?.response?.data?.errors;

      if (errors) {
        Object.values(errors).forEach((messages) => error(messages[0]));
      } else {
        error(message || 'ویرایش باشگاه با خطا مواجه شد');
      }
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Master>
      <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-3 my-3'>
        <div className='d-flex flex-row align-items-center'>
          <i className='fad fa-edit f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-14 font-weight-bold mb-0'>
            ویرایش باشگاه
          </h1>
        </div>
        <ClubStatusBadge status={club.status} label={club.status_label} />
      </div>

      {club.status === 2 && club.reject_reason && (
        <div className='alert alert-danger f-13 mb-3'>
          <strong>دلیل رد:</strong> {club.reject_reason}
        </div>
      )}

      <div className='card border shadow-sm'>
        <div className='card-body p-4'>
          <ClubForm
            initialValues={{
              title: club.title,
              address: club.address,
              phone: club.phone,
              province_id: club.province_id,
              city_id: club.city_id,
              coach_national_code: club.coach?.national_card_id || '',
            }}
            existingImages={club.images || []}
            onSubmit={handleSubmit}
            submitLoading={submitLoading}
            submitLabel='ذخیره تغییرات'
          />
        </div>
      </div>
    </Master>
  );
};

export default EditClub;
